import { render, staticRenderFns } from "./UsersCard.vue?vue&type=template&id=472796bd&scoped=true"
import script from "./UsersCard.vue?vue&type=script&lang=js"
export * from "./UsersCard.vue?vue&type=script&lang=js"
import style0 from "./UsersCard.vue?vue&type=style&index=0&id=472796bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472796bd",
  null
  
)

export default component.exports